/**
 * Get container HTML element for react-laag.
 *
 * @param id string
 * @returns HTMLElement | undefined
 */ const getContainer = (id)=>{
    if (typeof window === 'undefined') return undefined;
    const container = document.querySelector(`#${id}`);
    return container || undefined;
};

export { getContainer };
//# sourceMappingURL=container.js.map
